import {atomWithStorage} from 'jotai/utils';

/** Per-browser flag: which home banners (keyed by banner `type`) the viewer has dismissed. */
export type BannerDismissedStore = Record<string, boolean>;

export const bannerDismissedAtom = atomWithStorage<BannerDismissedStore>(
  'home:bannerDismissed',
  {},
  undefined,
  {getOnInit: true}
);
